module.exports = __webpack_public_path__ + "static/media/number5.94911df2.mp3";